module.exports = __webpack_public_path__ + "img/probanner.e5c5e684.jpg";